<template>
  <div class="skeParent">
    <el-skeleton loading animated class="itemChild">
      <template slot="template">
        <div class="item-header">
          <!--<slot name="head-title">-->
            <div class="head-title">
              <el-skeleton-item style="width: 180px; height: 22px" />
              <el-skeleton-item style="width: 320px; height: 20px" />
            </div>
          <!--</slot>-->
        </div>
        <!--<slot name="cell-main">-->
          <div class="cell-main">
            <el-skeleton-item />
            <el-skeleton-item />
            <el-skeleton-item />
            <el-skeleton-item />
          </div>
        <!--</slot>-->
        <!--<slot name="main-footer">-->
          <div class="main-footer">
            <el-skeleton-item />
            <el-skeleton-item style="width: 50%"/>
            <el-skeleton-item style="width: 60%"/>
          </div>
        <!--</slot>-->
      </template>
    </el-skeleton>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.skeParent {
  width: 569px;
  background: #fff;
  .itemChild {
    display: flex;
    flex-direction: column;
    border: 1px solid #e0e3ea;
    height: 100%;
    width: 100%;
    cursor: pointer;
    .item-header {
      height: 68px;
      background: #f3f6f9;
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;
      .head-title {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        margin-left: 10px;
        .head-msg {
          padding-left: 10px;
          padding-right: 50px;
        }
      }
    }

    .cell-main {
      flex: 1;
      display: flex;
      flex-direction: row;
      background: #fff;
      height: 180px;
      /deep/ .el-skeleton__text {
        width: 22%;
        margin-left: 10px;
        margin-top: 20px;
      }
    }
    .main-footer {
      height: 110px;
      border-top: 1px #e0e3ea dashed;
      padding-top: 10px;
      position: relative;
      display: flex;
      flex-direction: column;
      padding-left: 10px;
      box-sizing: border-box;
      /deep/ .el-skeleton__text {
        width: 40%;
        /* padding: 0 10px; */
        margin-left: 10px;
        margin-top: 10px;
      }
    }
  }
}
</style>
